import React from 'react'
import { styled } from '@mui/material/styles'
import { Container, Typography } from '@mui/material/'
import { StyledArticle } from '@components/organisms/Article/StyledArticle'
import { useGetStaticPageQuery, StaticPageType } from '@services/graphcms/client'

const PREFIX = 'index'

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
}

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.container}`]: {
    marginTop: theme.spacing(2),
    minHeight: '80vh',
  },

  [`& .${classes.title}`]: {
    fontWeight: 'bold',
  },
}))

type Props = {
  type: StaticPageType
}

export function StaticPage(props: Props) {
  const { data, error, loading } = useGetStaticPageQuery({
    variables: {
      staticPageType: props.type,
    },
  })

  if (error) {
    return <div>404 ページが存在しません</div>
  }

  if (loading) {
    return null
  }

  if (!data || !data.staticPage) {
    return <div>404 ページが存在しません</div>
  }

  return (
    <StyledContainer className={classes.container} maxWidth="md">
      <Typography align="center" className={classes.title} variant="h5">
        {data.staticPage.title}
      </Typography>
      <div>
        <StyledArticle dangerouslySetInnerHTML={{ __html: data.staticPage.content.html }} />
      </div>
    </StyledContainer>
  )
}
